import { IServerCountryInfo } from '../../../../shared/constants/international_constants';

import { Api as apiService } from '../api';

export abstract class InternationalizationApi {
  static readonly internationalApiURL: string = '/api/web/international';
  static getServerCountryOptions(): Promise<{
    countryList: IServerCountryInfo[];
    defaultCountry: IServerCountryInfo;
  }> {
    return apiService.responseToJSONAndToastError(
      apiService.get(`${InternationalizationApi.internationalApiURL}/get_server_country_options`)
    );
  }
}
